// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#3C494C',
    light: '#d3eef9',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#C7B8A1',
    contrastText: '#0A5285',
    light: '#D9EDF7',
  },
  text: {
    primary: '#262626',
    secondary: '#273645',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F4F4F4',
    paper: '#FFF',
    default: '#FFF',
    header: 'rgba(17, 183, 205, 0.8)',
    footer: '#F8F7F2',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#000000',
    tableHead: '#C7B8A1',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#BC942F',
    secondary: 'rgb(240,243,243)',
    light: '#F7F7F7',
    secondaryLight: '#FBF7F5',
  },
  verticalBar: {
    used: '#25AAE2',
    unused: '#d3eef9',
    unlimited: '#C0C0C0',
  },
};
